import React, { Component, createRef } from 'react'
import { withRouter, Link } from "react-router-dom"
import { withCookies } from "react-cookie"
import { Header, Loader, Breadcrumb } from 'semantic-ui-react'

//import ReactHtmlParser, { processNodes } from 'react-html-parser'
import parse, {domToReact} from 'html-react-parser'
import AnimatedPaths from '../../components/AnimatedPaths/index'

import decodeHtml from "../../helpers";

import Four0Four from "../Four0Four/index"
import Four0Eight from "../Four0Eight/index"

import configLoader from '../../helpers/configLoader'
import MapBackground from '../../components/MapBackground'
import Video from '../../components/Video'
import TroveLogo from '../../components/Trove'

let index = 0

// What the fuck is this?
// Well, this is a thing that converts the HTML from WP into React components.
const options = {
    replace: (node) => {
        index ++;

        if (node.type === 'tag' && node.name === 'a' && node.attribs.href && node.attribs.href.substring(0, 4) !== 'http') {
            if (node.attribs.href[0] === '#') {
                return <a
                    key={'a_' + index}
                    onClick={(e) => {
                        e.preventDefault();
                        let element = document.getElementById(node.attribs.href.substring(1));
                        if (element) {
                            element.scrollIntoView({behavior: 'smooth'})
                        }
                    }}
                    href={node.attribs.href} className={node.attribs.class}
                >
                    {domToReact(node.children, options)}
                </a>
            }
            return <Link key={'link_' + index} to={node.attribs.href} className={node.attribs.class}>
                {domToReact(node.children, options)}
            </Link>
        }
        if (node.type === 'tag' && node.name === 'video') {
            if (node.attribs.autoplay || node.attribs.autoplay === '') {
                // This just gets rid of warning, and is currently ignored as all videos autoPlay
                delete node.attribs.autoplay
            }

            return <Video
                key={'video_' + index}
                {...node.attribs}
            />
        }
        if (node.type === 'tag' && node.name === 'div' && node.attribs.class && node.attribs.class === 'mapBackground') {
            return <MapBackground
                key={'map_' + index}
                locationCount={0}
                className='mapBackground'
                showPanZoom={false}
                zoom={11}
            />
        }

        if (node.type === 'tag' && node.name === 'strong' && node.children[0] && node.children[0].data === 'Trove') {
            return <TroveLogo key={'trove_' + index}/>
        }
    }
}

class Page extends Component {
    contextRef = createRef();

    constructor(props) {
        super(props);
        this.state = {
            token: null,
            page: false,
            title: false,
            slug: false,
            error: false,
            loading: false,
            breadcrumbs: [],
        };
    }

    componentDidMount() {
        this.loadPage()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params !== this.props.match.params) {
            this.loadPage()
        }
    }

    loadPage = () => {
        let url = this.props.match.url
        if (!url || url === '/') {
            url = "frontpage"
        }
        this.setState({
            loading: true,
        });
        fetch(configLoader.ApiPages + '?url=' + url,
            {
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                //'Authorization': 'Bearer ' + this.props.user.token
            }
        }).then(response => {
            if (response.status === 200) {
                return response.json()
            } else {
                throw response.status
            }
        }).then(data => {
            if (!data || data.length < 1) {
                this.setState({
                    error: <Four0Four />,
                    loading: false,
                })
            } else {
                let pageData = data[0];

                document.title = decodeHtml(pageData.title.rendered) + ' - ' + configLoader.title;
                if (pageData.breadcrumbs.length > 0) {
                    pageData.breadcrumbs.push({
                        key: pageData.title.rendered,
                        content: pageData.title.rendered,
                        link: false,
                        active: true
                    })
                }
                this.setState({
                    error: false,
                    loading: false,
                    title: pageData.title.rendered,
                    page: pageData.content.rendered,
                    slug: pageData.slug,
                    breadcrumbs: pageData.breadcrumbs
                }, () => {
                    if (this.child)
                        this.child.onScroll();
                    if (typeof window.playAnimation === 'function') {
                        window.playAnimation()
                    }
                })
            }
        }).catch(error =>{
            console.log(error);
            this.setState({
                error: <Four0Eight />,
                loading: false,
            })
        })
    };

    render() {
        if (!this.state.title && !this.state.error) {
            return (
                <Loader active inline='centered' className={'centeredLoader'} />
            )
        }
        let breadcrumbs = "";
        if (this.state.breadcrumbs.length > 0) {
            breadcrumbs = <Breadcrumb icon='right angle' sections={this.state.breadcrumbs} />
        }
        if (this.state.loading) {
            return (
                <Loader active inline='centered' className={'centeredLoader'} />
            )
        }
        return (
            <>
                <AnimatedPaths onRef={ref => (this.child = ref)} />
                <article className={ "page type-page ui text" + this.state.slug }>
                    { (!this.state.error) ?
                        <>
                            { breadcrumbs }
                            {(this.state.slug !== 'frontpage'?
                                    <Header as={'h1'}>{ parse(this.state.title, options) }</Header>
                                    : ''
                            )}
                            { parse(this.state.page, options) }
                        </>
                        :
                        this.state.error
                    }
                </article>
            </>
        )
    }
}
export default withRouter(withCookies(Page))